import { generatePath, useHistory } from 'react-router-dom'
import { mdiArrowRight } from '@mdi/js'
import { useIntl } from 'react-intl'

import { useAppSelector } from 'app/hooks'
import routes from 'app/routes'

import CommonLinkButton from 'components/Button/CommonLinkButton'
import { useHomeRouteParams } from 'features/home/hooks'
import {
  homeAvailableSoftwareSelector,
  homeConfigSelectors,
  homeSoftwareVersionSelector,
  selectedHomeSelector,
} from 'features/home/selectors'
import {
  SoftwareVersionContainer,
  SoftwareVersionLabel,
  SoftwareVersionWrapper,
  StyledUpdatesButton,
} from './styles'
import { StyledIcon, SubInfoBlackCardDate } from '../../styles'
import { SectionLabel } from 'components/Typography'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import { softwareVersionMessages } from '../../messages'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import {
  useSoftwareUpdates,
  useValidSoftware,
} from 'features/home/components/HomeSoftware/utils'
import { Spinner } from 'components/Loader'

function SoftwareVersion() {
  const { homeId } = useHomeRouteParams()
  const history = useHistory()
  const { formatMessage } = useIntl()

  const selectedHome = useAppSelector(selectedHomeSelector.data)
  const hostConfig = useAppSelector(homeConfigSelectors.data)
  const availableSoftware = useAppSelector(homeAvailableSoftwareSelector.data)
  const isFetchingAvailableSoftware = useAppSelector(
    homeAvailableSoftwareSelector.isFetching
  )

  const validSoftware = useValidSoftware(
    hostConfig?.hostMachineType || 0,
    selectedHome!,
    availableSoftware!
  )

  const availableUpdates = useSoftwareUpdates(selectedHome, validSoftware)

  const currentRootId = useAppSelector(currentRootDomainIdSelector)
  const { softwareVersionLabel, createdDate } = useAppSelector(
    homeSoftwareVersionSelector
  )

  const openSoftwareUpdatesPage = () => {
    if (currentRootId) {
      const homeSoftwarePath = generatePath(routes.homeSoftware, {
        homeId,
        rootDomainId: currentRootId,
      })
      history.push(homeSoftwarePath)
    }
  }

  // TODO Add localization
  return (
    <SoftwareVersionContainer>
      <SectionLabel>
        {formatMessage(softwareVersionMessages.daVinciTitle)}
        <CommonLinkButton onClick={openSoftwareUpdatesPage}>
          <StyledIcon path={mdiArrowRight} size={1} />
        </CommonLinkButton>
      </SectionLabel>
      <SoftwareVersionWrapper>
        <strong>{softwareVersionLabel}</strong>
        <SoftwareVersionLabel>
          {formatMessage(softwareVersionMessages.updatedTimeLabel)}&nbsp;
          <SubInfoBlackCardDate>
            <IntlFormattedDate date={createdDate} withTime />
          </SubInfoBlackCardDate>
        </SoftwareVersionLabel>
      </SoftwareVersionWrapper>
      <StyledUpdatesButton
        type="button"
        variant="darkOutlined"
        onClick={openSoftwareUpdatesPage}
      >
        {isFetchingAvailableSoftware ? (
          <Spinner size={1} />
        ) : (
          formatMessage(
            availableUpdates.length > 0
              ? softwareVersionMessages.updatesAvailableLabel
              : softwareVersionMessages.manageUpdatesLabel
          )
        )}
      </StyledUpdatesButton>
    </SoftwareVersionContainer>
  )
}

export default SoftwareVersion
